var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.426,
    cy: 20,
    r: 20,
    fill: "#000",
    transform: "rotate(-180 20.426 20)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 8,
    d: "M6.553 19.565c0-3.828 1.512-7.297 3.969-9.807C12.948 7.28 16.296 5.74 20 5.74c3.704 0 7.052 1.54 9.478 4.02 2.457 2.509 3.969 5.978 3.969 9.806 0 3.828-1.512 7.297-3.969 9.807-2.426 2.479-5.774 4.02-9.478 4.02-4.81 0-9.015-2.598-11.388-6.47-1.307-2.133-2.059-4.656-2.059-7.357z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.25,
    r: 16.25,
    fill: "#000",
    transform: "rotate(-180 20 20)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStealth);
export default __webpack_public_path__ + "static/media/stealth.560bed8f2ee11cdc5fe20cda3a086d23.svg";
export { ForwardRef as ReactComponent };